
import { Options, prop, Vue } from "vue-class-component";
import removeNewLineWhitespace from "@/app/infrastructures/misc/common-library/RemoveNewLineWhitespace";
import { FlagsMedusa } from "@/feature-flags/flags-misc-medusa";
import SelectPhoneCountryV2 from "./select-phone-country-v2.vue";
import SelectCustomerV2 from "@/app/ui/views/shipment/booking/create-booking-v2/components/select-customer-v2.vue";
import Checkbox from "primevue/checkbox";
import { ValidateInputPhoneNumber } from "@/app/infrastructures/misc/common-library/ValidateInputPhoneNumber";
import EditCustomerForm from "./edit-customer/edit-customer-form.vue";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { BookingController } from "@/app/ui/controllers/BookingController";
import { LocationController } from "@/app/ui/controllers/LocationController";
import debounce from "lodash/debounce";
import { codePhoneCountry } from "@/app/ui/views/shipment/booking/booking-utils";
import { DetailClientManagement } from "@/domain/entities/ClientManagement";
import { CustomerManagementController } from "@/app/ui/controllers/CustomerManagementController";
import { RequestCustomerList } from "@/domain/entities/Customer";
import { Commodity, CommodityList } from "@/domain/entities/Commodity";
import { CommodityController } from "@/app/ui/controllers/CommodityController";
import { Pagination } from "@/domain/entities/Pagination";
import { RequestListCommodity } from "@/data/payload/api/CommodityApiRequest";
import { FlagsPermissionBooking } from "@/feature-flags/flag-booking";
import { ResponsePhoneChecker } from "@/domain/entities/Booking";
import OverlayPanel from "primevue/overlaypanel";

class Props {
  modelValue = prop<any>({
    required: true,
  });
  accountIsNonForeign = prop<boolean>({
    required: true,
  });

  disableSaveSender = prop<boolean>({
    default: false,
    required: true,
  });

  payload = prop<any>({
    required: true,
  });

  error = prop<any>({
    required: true,
  });

  formType = prop<string>({
    required: true,
  });

  errorMessageName = prop<string>({
    required: true,
  });

  errorMessageAddress = prop<string>({
    required: true,
  });

  errorMessageDistrict = prop<string>({
    required: true,
  });

  detailClientManagement = prop<DetailClientManagement>({
    default: new DetailClientManagement(),
    required: false,
  })
}

@Options({
  emits: ["setFieldIndex", "getWoodPacking", "loadUpsellingOrigin", "getDocumentInternational"],
  components: {
    SelectPhoneCountryV2,
    Checkbox,
    EditCustomerForm,
    SelectCustomerV2,
    OverlayPanel
  }
})
export default class SectionSenderDetail extends Vue.with(Props) {
  isOpenUpload = false;
  originCityList: Array<any> = [];

  phoneNumberError = {
    success: false,
    error: false,
    message: ""
  };

  selectedCustomer: any = {
    customerAddress: "",
    customerId: 0,
    customerName: "",
    customerPhoneNumber: ""
  };

  errorMessageAddressLocal = "";
  errorMessageNameLocal = "";

  errorEmbargo = {
    originCity: false,
    destinationCity: false,
    productType: false,
    comodity: false,
    weightStatus: false,
    lengthStatus: false,
  };

  mounted(): void {
    this.modelValue.phoneCodeSender = this.accountIsNonForeign ? "+62" : "+60";
    this.modelValue.phoneFlagSender = this.accountIsNonForeign
      ? "indonesia"
      : "malaysia";
  }

  onChangeDistrict() {
    this.onUpdateEmbargoStatusFail();
    this.setProductUpsellingcityOrigin();
    this.getWoodPacking();
    this.loadUpsellingProduct();
    this.loadDocumentInternational();
  }

  get maxAddressLength() {
    return FlagsMedusa.config_max_address.getValue();
  }

  get isClientAccount() {
    return this.getAccount.accountType === 'internal'
  }

  // FUNCTIONS

  showForm() {
    this.isOpenUpload = true;
  }

  onSaveCustomer = debounce((event: any, data) => {
    if (!event.target.checked) {
      return;
    }
    if (data.sender && data.phoneSender && data.phoneCodeSender) {
      BookingController.addCustomer({
        name:
          typeof data.sender === "object"
            ? data.sender.customerName
            : data.sender,
        phone: `${data.phoneCodeSender.substring(1)}${data.phoneSender}`,
        address: data.addressSender
      });
    }
  }, 1000);

  validateSenderName(value: string) {
    const trimmed = value.trim();
    const min3Chars = trimmed.length < 3;
    const empty = trimmed === "";
    this.errorMessageNameLocal = "";
    if (min3Chars) {
      this.errorMessageNameLocal = "Nama pengirim minimum 3 karakter.";
    }
    if (empty) {
      this.errorMessageNameLocal = "Nama pengirim wajib diisi.";
    }
    const senderError = min3Chars || empty;
    this.error.sender = senderError;
    this.$emit("update:error", { ...this.error, sender: senderError });
  }

  validateAddressSender(value: string) {
    const min3Chars = value.length < 3;
    const empty = value === "";
    this.errorMessageAddressLocal = "";
    if (min3Chars) {
      this.errorMessageAddressLocal = "Alamat pengirim minimum 3 karakter.";
    }
    if (empty) {
      this.errorMessageAddressLocal = "Alamat pengirim wajib diisi.";
    }
    const senderError = min3Chars || empty;
    this.error.addressSender = senderError;
    this.$emit("update:error", { ...this.error, addressSender: senderError });
  }

  replaceNewLine(value: string) {
    const removedNewLineAddress = removeNewLineWhitespace(value, " ");
    this.modelValue.addressSender = removedNewLineAddress;
    this.$emit("update:modelValue", { ...this.modelValue });
    return removedNewLineAddress;
  }

  setPhoneSender(val: string, code = "") {
    let selectedPhoneCode = "";
    if (
      this.modelValue.phoneCodeSender !== null &&
      this.modelValue.phoneCodeSender !== ""
    ) {
      selectedPhoneCode = this.modelValue.phoneCodeSender.substring(1);
    }
    const phoneNumberWithCode = `${selectedPhoneCode}${val}`;
    this.phoneNumberError = ValidateInputPhoneNumber(phoneNumberWithCode);
    this.setErrorPhoneCodeSender(this.phoneNumberError.error);
    this.modelValue.phoneSender = val;
    this.$emit("update:modelValue", { ...this.modelValue });
    this.fetchCustomer(val, code);
    this.checkFraudNumber(phoneNumberWithCode);
  }

  setPhoneCodeSender(val: string) {
    this.modelValue.phoneCodeSender = val;
    this.$emit("update:modelValue", { ...this.modelValue });
  }

  setErrorPhoneCodeSender(status: boolean) {
    this.error.phoneCodeSender = status;
    this.$emit("update:error", { ...this.error, phoneCodeSender: status });
  }

  get origin() {
    const detail = LocationController.districtDetail;
    return {
      id: detail.id,
      name: `${detail.name}, ${detail.cityName}`,
      code: `${detail.code}`,
      cityCode: `${detail.cityCode}`,
      zipCode: `${detail.originZipCode}`,
    };
  }

  get isShipperAndConsigneeAddressIdentical() {
    if (
      this.modelValue.addressSender === "" ||
      this.modelValue.addressReceiver === ""
    ) {
      return false;
    }
    return (
      String(this.modelValue.addressSender).toLowerCase() ===
      String(this.modelValue.addressReceiver).toLowerCase()
    );
  }

  get getAccount(): any {
    return {
      accountType: AccountController.accountData.account_type,
      cityCode: AccountController.accountData.account_type_detail
        .partnerLocation
        ? AccountController.accountData.account_type_detail.partnerLocation
            .city_code
        : "",
      accountClientId: AccountController.accountData.account_type_detail.id
        ? AccountController.accountData.account_type_detail.id
        : "",
      isCodBooking:
        AccountController.accountData.account_type_detail.partnerIsCodBooking,
      accountTypeDetail: AccountController.accountData.account_type_detail
    };
  }

  get isErrorEmbargo() {
    return BookingController.isErrorEmbargo;
  }

  fetchOriginCity = debounce(async (search: string) => {
    const typeAccuracyAllowed = true;
    const response = await LocationController.getDistrictList({
      search: search,
      status: "active",
      page: 1,
      limit: typeAccuracyAllowed ? 50 : 10,
      cache: true,
    });
    this.originCityList = this.filterDistrict(response);
  }, 250);

  get isLoadingOriginCity() {
    return LocationController.isLoadingDistrict;
  }

  filterDistrict(response: any) {
    return response
      .filter((key: any) => key.status.toLowerCase() === "active")
      .map((e: any) => ({
        id: e.id,
        name: `${e.name}, ${e.cityName}`,
        code: `${e.code}`,
        cityCode: `${e.cityCode}`,
        status: e.status,
        type: e.type,
        cityId: e.cityId,
        "vendor_code": e.vendorCode,
        isCod: e.isCod,
        isFtz: e.isFtz
      }));
  }

  onFocusOriginCity() {
    if (!this.originCityList.length || !this.modelValue.originCity) {
      LocationController.setLoadingDistrict(true);
      this.fetchOriginCity("");
    }
    this.$emit("setFieldIndex", 9);
  }

  onUpdateEmbargoStatusFail() {
    if (this.isErrorEmbargo) {
      this.updateStatusErrorEmbargo(false);
    }
  }

  updateStatusErrorEmbargo(status: boolean) {
    this.errorEmbargo.originCity = status;
    this.errorEmbargo.destinationCity = status;
    this.errorEmbargo.productType = status;
    this.errorEmbargo.comodity = status;
    this.errorEmbargo.weightStatus = status;
    this.errorEmbargo.lengthStatus = status;
  }

  setProductUpsellingcityOrigin() {
    this.pickProductUpselling(this.modelValue.originCity);
  }

  pickProductUpselling(val: any) {
    if (val) {
      this.loadUpsellingProductByCondition();
    } else {
      this.resetProductUpselling();
    }
  }

  loadUpsellingProductByCondition() {
    this.loadUpsellingProductForManualBook();
    this.loadUpsellingProductForClientBook();
  }

  loadUpsellingProductForManualBook() {
    if (
      this.isFormBookManual &&
      this.OriginAndDestinationFullfilledForManualBook
    ) {
      this.loadUpsellingProduct();
    }
  }

  loadUpsellingProductForClientBook() {
    if (this.isFormBookClient && this.fullFilledUpsellingProductForClient) {
      this.loadUpsellingProduct();
    }
  }

  get isFormBookManual() {
    return this.formType === "manual";
  }

  get isFormBookClient() {
    return this.formType === "client";
  }

  get OriginAndDestinationFullfilledForManualBook() {
    return this.origin.id && this.modelValue.destinationCity;
  }

  get fullFilledUpsellingProductForClient() {
    return (
      this.originFullfilledForManualBook &&
      this.clientNameAndDestinationFullfilledForManualBook
    );
  }

  get originFullfilledForManualBook() {
    return this.modelValue.originCity || this.origin.id;
  }

  get clientNameAndDestinationFullfilledForManualBook() {
    return this.modelValue.clientName && this.modelValue.destinationCity;
  }

  loadUpsellingProduct() {
    this.$emit("loadUpsellingOrigin");
  }

  get clientlientIdForProductUpselling() {
    let accountRefId = 0;
    let accountType = "";

    if (this.isFormBookManual && this.getAccount.accountType === "partner") {
      accountRefId = 0;
      accountType = "pos";
    } else if (
      this.isFormBookClient &&
      this.getAccount.accountType === "partner"
    ) {
      accountRefId = this.modelValue.clientName.id;
      accountType = "client";
    } else if (
      this.isFormBookManual &&
      this.getAccount.accountType === "client"
    ) {
      accountRefId = this.getAccount.accountClientId;
      accountType = "client";
    } else {
      accountRefId = this.modelValue.clientName.id;
      accountType = "client";
    }

    return {
      accountRefId,
      accountType,
    };
  }

  resetProductUpselling() {
    const renderPoster: any = this.$refs.renderPoster;
    renderPoster?.resetAllProduct();
  }

  getWoodPacking() {
    this.modelValue.isWoodpack = false;
    this.$emit("update:modelValue", { ...this.modelValue, isWoodpack: false });
    this.$emit("getWoodPacking");
  }

  onChooseSenders(item: any, isChoosen = true) {
    if (!item) {
      return false;
    }

    if (item.customerCommodityCode) {
      CommodityController.getDetailCommodityByCode(
        item.customerCommodityCode
      ).then(commodity => {
        CommodityController.getCommodityList(
          new RequestListCommodity({ commodityStatus: "active" })
        ).then(() => {
          if (commodity.commodity_code) {
            BookingController.setDataCommoditySender({
              id: commodity.commodity_id,
              name: this.accountIsNonForeign
                ? commodity.commodity_name
                : commodity.commodity_name_en || " ",
              code: commodity.commodity_code,
              isDangerousGoods: commodity.isDangerousGoods,
              isQuarantine: commodity.isQuarantine,
              status: commodity.commodity_status
            });

            this.$emit("autofillCommodity");
            return;
          }
        });
      });

      this.$emit("autofillCommodityNotFound");
    }

    item = {
      ...item,
      customerPhoneCode: codePhoneCountry(item.customerPhoneNumber).code,
      customerPhoneNumber: codePhoneCountry(item.customerPhoneNumber).number
    };

    BookingController.setDataSender(item);
    this.error.phoneCharMinimalSender =
      item.customerPhoneNumber.length < 5 && isChoosen;

    this.validatePhoneSender(item.customerPhoneNumber);
    this.validateSenderName(this.modelValue.sender);
    this.setErrorPhoneCodeSender(this.phoneNumberError.error);
    this.validateAddressSender(item.customerAddress);
  }

  validatePhoneSender(value: string) {
    if (!value) {
      return;
    }
    const phoneArray = value.split("");
    if (this.detectPhoneNumber(phoneArray) && phoneArray.length > 14) {
      const newPhone = value.slice(0, -1);
      BookingController.setPhoneSender(newPhone);
    } else {
      BookingController.setPhoneSender(value);
    }
  }

  detectPhoneNumber(phoneArray: Array<string>) {
    return phoneArray.find(
      () => phoneArray[0] === "0" && phoneArray[1] === "8"
    );
  }

  setNameCustomer(search: string, type: string) {
    if (type === "senders") {
      BookingController.setNameSender(search); // set payload even if not choosing
    }
    if (type === "receivers") {
      BookingController.setNameReceiver(search); // set payload even if not choosing
    }
    if (search.length === 0) {
      return;
    }
    this.fetchCustomer(search);
  }

  fetchCustomer(search: string, code = "") {
    if (search.length > 2) {
      if (this.isFormBookClient) {
        if (this.detailClientManagement.clientPhone !== '') this.fetchBySearch(search, code, this.detailClientManagement.id, "client");
      } else {
        this.fetchBySearch(search, code);
      }
    }
  };

  fetchBySearch = debounce((search: string, code = "", refId?: number, refType?: string) => {
    BookingController.getCustomerList({
      search: code.substring(1) + search,
      cache: true,
      refId: refId,
      refType: refType,
      isSender: true
    });
  }, 1000)

  get isLoadingCustomer() {
    return BookingController.isLoadingCustomer;
  }

  get senders() {
    return this.getPhoneNumbers;
  }

  get getPhoneNumbers() {
    const list = BookingController.senderCustomerList.data;
    if (this.isFormBookClient && this.detailClientManagement.clientPhone == "") return []
    if (list.length !== 0) {
      return BookingController.senderCustomerList.data.map((item) => {
        return {
          ...item,
          customerPhoneNumber: `${item.customerPhoneNumber}`
        };
      });
    } else {
      return list;
    }
  }

  editItem(item: any) {
    this.selectedCustomer = item;
    this.showForm();
  }

  loadDocumentInternational() {
    this.$emit("getDocumentInternational")
  }

  get manualBooking() {
    return BookingController.manualBooking;
  }

  get isErrorFraudLimited() {
    return BookingController.phoneCheckerData.status === "limited";
  }

  get isErrorFraudSuspected() {
    return BookingController.phoneCheckerData.status === "suspected";
  }

  checkFraudNumber = debounce(async (val: any) => {
    if (ValidateInputPhoneNumber(val).error) {
      return;
    }

    if (this.isFormBookClient) {
      return;
    }

    // reset state before hit API
    BookingController.setPhoneCheckerData(new ResponsePhoneChecker());

    // Hit API fraud number
    await BookingController.phoneChecker(val);

    const isBlacklist = BookingController.phoneCheckerData.isBlacklist;
    const errorFraudLimited =
      BookingController.phoneCheckerData.status === "limited" &&
      FlagsPermissionBooking.disable_cod_dfod_for_limited_number.isEnabled();

    if (isBlacklist || errorFraudLimited) {
      this.manualBooking.isCOD = false;
      this.manualBooking.isDFOD = false;
    }
  }, 1000);

  toggleTooltip(event: any) {
    const refs: any = this.$refs;
    refs["opTooltip"].toggle(event);
  }
}
